import { z, ZodType } from "zod";

export const Codelist = <T>(codeType: ZodType<T, any, any>) =>
  z.object({
    code: codeType,
  });
